export const fixADAElements = ({ id, list, value }) => {
  const elementsListId = `${id}_list`;
  const elementList = document?.getElementById(elementsListId);
  if (!elementList) return;
  const role = elementList?.getAttribute('role');
  if (role) {
    const parent = elementList?.parentElement;
    const newADANode = document?.createElement('div');
    newADANode?.setAttribute('id', elementsListId);
    newADANode?.setAttribute('role', role);
    newADANode?.setAttribute(
      'style',
      'height: 0px; width: 0px; overflow: hidden;',
    );
    let innerHTML = '';
    list?.forEach((option, index) => {
      innerHTML += `<div role="option" id="${elementsListId}_${index}" aria-selected="${
        value === option?.value
      }">${option?.label}</div>`;
    });
    newADANode.innerHTML = innerHTML;
    parent?.appendChild(newADANode);
    elementList?.remove();
  }
};
